import { render, staticRenderFns } from "./CustomersIcon.vue?vue&type=template&id=2b4548c0&scoped=true"
var script = {}
import style0 from "./CustomersIcon.vue?vue&type=style&index=0&id=2b4548c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4548c0",
  null
  
)

export default component.exports